var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reports-widget-component"},[_c('ct-panel',{attrs:{"title":_vm.$t('reports.form.title'),"enableReload":false}},[_c('div',{attrs:{"slot":"panel-content"},slot:"panel-content"},[_c('ct-reports-form')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }